//Auth
export const AUTHENTICATION = "AUTHENTICATION";
export const VALIDATION = "VALIDATION";
export const OTP_SENT = "OTP_SENT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const GUEST_LOGIN_SUCCESS = "GUEST_LOGIN_SUCCESS";
export const ACCOUNT_CREATED = "ACCOUNT_CREATED";
export const LOGOUT = "LOGOUT";

//Common
export const SCHOOL_LIST = "SCHOOL_LIST";
export const GUEST_MODAL = "GUEST_MODAL";
export const SCHOOL_INFO = "SCHOOL_INFO";

//Dashboard
export const FILTER_LIST = "FILTER_LIST";
export const BASIC_STATE = "BASIC_STATE";
export const STUDENT_GALLERY = "STUDENT_GALLERY";
export const ACTIVE_STUDENT = "ACTIVE_STUDENT";
export const STUDENTS_DATA = "STUDENTS_DATA";
export const USER_DATA = "USER_DATA";
export const SET_FILTERS = "SET_FILTERS";
export const STUDENT_FILTER = "STUDENT_FILTER";
export const TEACHER_FILTER = "TEACHER_FILTER";
export const USER_FILTER = "USER_FILTER";
export const GALLERY_FILTER = "GALLERY_FILTER";
export const STUDENT_REPORT_LIST = "STUDENT_REPORT_LIST";
export const ASSOCIATED_TEACHERS = "ASSOCIATED_TEACHERS";
export const STUDENT_ACTIVE_PAGE = "STUDENT_ACTIVE_PAGE";
export const QUIZ_STUDENT_ACTIVE_PAGE = "QUIZ_STUDENT_ACTIVE_PAGE";
export const TEACHER_ACTIVE_PAGE = "TEACHER_ACTIVE_PAGE";
export const GALLERY_STUDENT_LIST = "GALLERY_STUDENT_LIST";
export const ACTIVE_QUIZ_STUDENT = "ACTIVE_QUIZ_STUDENT";

//Report Card
export const REPORT_FILTER = "REPORT_FILTER";
export const REPORT_CARD = "REPORT_CARD";
export const REPORT_CARD_DETAILS = "REPORT_CARD_DETAILS";

//Learning Programs
export const ONGOING_EVENTS = "ONGOING_EVENTS";
export const PAST_EVENTS = "PAST_EVENTS";
export const EVENT_DETAILS = "EVENT_DETAILS";
export const CATEGORY_LIST = "CATEGORY_LIST";
export const ACTIVITY_LIST = "ACTIVITY_LIST";
export const EVENT_PROPS = "EVENT_PROPS";
export const COMP_LIST = "COMP_LIST";
export const EXP_LIST = "EXP_LIST";
export const QUIZ_LIST = "QUIZ_LIST";
export const COMP_AGE = "COMP_AGE";
export const EXP_AGE = "EXP_AGE";
export const QUIZ_AGE = "QUIZ_AGE";
export const PENDING_SUBMISSION_KIDS = "PENDING_SUBMISSION_KIDS";
export const EVENT_STUDENT = "EVENT_STUDENT";
export const SUBMISSION_LIST = "SUBMISSION_LIST";
export const ONGOING_EVENT_FILTER = "ONGOING_EVENT_FILTER";
export const PAST_EVENT_FILTER = "PAST_EVENT_FILTER";

//Student Management
export const STUDENT_LIST = "STUDENT_LIST";
export const SEARCH_STUDENT_LIST = "SEARCH_STUDENT_LIST";
export const KID_FILTER = "KID_FILTER";
export const SEARCH_KID_LIST = "SEARCH_KID_LIST";
export const CLASS_LIST = "CLASS_LIST";
export const SECTION_LIST = "SECTION_LIST";


//Student Achievements
export const CERTIFICATE_LIST = "CERTIFICATE_LIST";
export const CERTIFICATE_FILTER = "CERTIFICATE_FILTER";
export const CERTIFICATE_KID_LIST = "CERTIFICATE_KID_LIST"


//REST FILTERS
export const RESET_FILTERS = "RESET_FILTERS";

//Ticket
export const TICKET_LIST = "TICKET_LIST";
export const TICKET_DETAILS = "TICKET_DETAILS";